import React from "react";

const LocationMap = () => {
  return (
    <section className="w-full bg-white py-20 px-6">

      {/* TITRE */}
      <div className="text-center mb-10">
<h2 className="text-2xl sm:text-3xl md:text-4xl font-black text-blue-600 uppercase mb-3">
            Notre Localisation
        </h2>

        <p className="text-gray-500 max-w-2xl mx-auto">
          Retrouvez facilement notre société grâce à notre emplacement sur Google Maps.
        </p>
      </div>

      {/* MAP + DESCRIPTION */}
<div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-10 items-center">
        {/* MAP - GAUCHE */}
        <div className="rounded-2xl overflow-hidden shadow-lg border h-[250px] sm:h-[350px] md:h-[450px] relative">

          <iframe
            title="Localisation J-Tronics"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3266.913981601747!2d10.90759747441631!3d35.03388176526522!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1301c136d2d11a4b%3A0x32a3cf4761c2c5a4!2zU29jacOpdMOpIEotVHJvbmljcw!5e0!3m2!1sfr!2stn!4v1781537148214!5m2!1sfr!2stn"
            className="w-full h-full"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
          ></iframe>

        </div>

        {/* DESCRIPTION - DROITE */}
<div className="bg-gray-50 p-6 md:p-8 rounded-2xl shadow-sm text-center md:text-left">
<h3 className="text-2xl sm:text-3xl font-bold text-blue-600 mb-4">
             Contactez J-Tronics
          </h3>

<p className="text-gray-600 mb-6 text-base md:text-lg">            N'hésitez pas à nous contacter pour toute information ou demande de projet.
          </p>

          {/* INFOS */}
          <div className="space-y-5 text-gray-700 text-base md:text-lg">

            {/* Adresse */}
            <div className="flex items-center gap-3">
              <span className="w-9 h-9 rounded-xl bg-blue-50 flex items-center justify-center text-blue-600 flex-shrink-0">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.8} stroke="currentColor" className="w-5 h-5">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
                </svg>
              </span>
              <span className="font-semibold">Djebeniana Office</span>
            </div>
<div className="flex items-center gap-3">
  <span className="w-9 h-9 rounded-xl bg-blue-50 flex items-center justify-center text-blue-600 flex-shrink-0">
    📞
  </span>
  <span>+216 26 800 203</span>
</div>
            

            {/* Email */}
            <div className="flex items-center gap-3">
              <span className="w-9 h-9 rounded-xl bg-yellow-50 flex items-center justify-center text-yellow-500 flex-shrink-0">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.8} stroke="currentColor" className="w-5 h-5">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
                </svg>
              </span>
              <span>commercial@jtronics.org</span>
            </div>

            {/* Horaires semaine */}
            <div className="flex items-center gap-3">
              <span className="w-9 h-9 rounded-xl bg-blue-50 flex items-center justify-center text-blue-600 flex-shrink-0">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.8} stroke="currentColor" className="w-5 h-5">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </span>
              <span>Lundi - Vendredi : 08:30 - 17:00</span>
            </div>

            {/* Horaires samedi */}
            <div className="flex items-center gap-3">
              <span className="w-9 h-9 rounded-xl bg-yellow-50 flex items-center justify-center text-yellow-500 flex-shrink-0">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.8} stroke="currentColor" className="w-5 h-5">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </span>
              <span>Samedi : 08:30 - 13:30</span>
            </div>

          </div>
        </div>

      </div>
    </section>
  );
};

export default LocationMap;